<div style="padding-top:10px; width: 800px;">
    <form style="width: 800px;border: 2;">
        <div class="row g-2 align-items-center">
            <div class="col-auto my-1">
               <!-- <label class="sr-only" for="inlineFormInputGroupUsername">Search </label> -->
                <div class="input-group">
                    <div class="input-group-prepend">
                        <div class="input-group-text"> Search </div>
                    </div>
                    <input type="text" class="form-control" #search_input id="search_input" placeholder="">
                </div>
            </div>
            <!-- <div class="col-auto my-1">
                <div class="form-check">
                    <input class="form-check-input" type="checkbox" id="autoSizingCheck2">
                    <label class="form-check-label" for="autoSizingCheck2">
                        Remember me
                    </label>
                </div>
            </div> -->
            <div class="col-auto my-1"> 
                <button type="submit" class="btn btn-outline-secondary" (click)="search(search_input.value)">Search </button>
            </div>
        </div>
    </form>
</div>